/**
 * Product Tracker — records the current product handle to localStorage.
 * Consumed by <recently-viewed-products> to render a slider of past visits.
 */
if (!customElements.get('p80-product-tracker')) {
  customElements.define(
    'p80-product-tracker',
    class ProductTracker extends HTMLElement {
      static STORAGE_KEY = 'p80RecentlyViewedProducts';
      static MAX_ITEMS = 10;

      connectedCallback() {
        const handle = this.dataset.handle?.trim();
        if (!handle) return;

        const items = this.getItems();
        const nextItems = [handle, ...items.filter((item) => item !== handle)].slice(
          0,
          ProductTracker.MAX_ITEMS
        );
        this.setItems(nextItems);
      }

      getItems() {
        try {
          const raw = localStorage.getItem(ProductTracker.STORAGE_KEY);
          const parsed = raw ? JSON.parse(raw) : [];
          if (!Array.isArray(parsed)) return [];
          return parsed
            .map((item) => (typeof item === 'string' ? item : item?.handle))
            .filter(Boolean);
        } catch {
          return [];
        }
      }

      setItems(items) {
        try {
          localStorage.setItem(ProductTracker.STORAGE_KEY, JSON.stringify(items));
        } catch {
          // localStorage unavailable (private browsing edge cases)
        }
      }
    }
  );
}
